// Melinam slider: scroll-snap track with arrows, dots, optional loop + autoplay.
// Markup: <mel-slider data-loop="true" data-autoplay="5" data-move-desktop="1" data-move-mobile="1">
//   .mel-slider__track > .mel-slider__slide ... ; optional .mel-slider__arrow--prev/--next and .mel-slider__dots
if (!customElements.get('mel-slider')) {
  customElements.define('mel-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.mel-slider__track');
      if (!this.track) return;
      this.slides = [...this.track.children];
      this.prev = this.querySelector('.mel-slider__arrow--prev');
      this.next = this.querySelector('.mel-slider__arrow--next');
      this.dots = this.querySelector('.mel-slider__dots');
      this.loop = this.dataset.loop === 'true';
      if (this.prev) this.prev.addEventListener('click', () => this.go(-1));
      if (this.next) this.next.addEventListener('click', () => this.go(1));
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.raf);
        this.raf = requestAnimationFrame(() => this.update());
      }, { passive: true });
      new ResizeObserver(() => this.build()).observe(this.track);
      const secs = parseFloat(this.dataset.autoplay || 0);
      if (secs > 0 && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const start = () => { clearInterval(this.timer); this.timer = setInterval(() => this.go(1, true), secs * 1000); };
        const stop = () => clearInterval(this.timer);
        this.addEventListener('mouseenter', stop);
        this.addEventListener('mouseleave', start);
        this.addEventListener('focusin', stop);
        this.addEventListener('focusout', start);
        start();
      }
    }
    perView() {
      const w = this.slides[0] ? this.slides[0].getBoundingClientRect().width : 1;
      return Math.max(1, Math.round(this.track.clientWidth / (w || 1)));
    }
    perMove() {
      const v = matchMedia('(min-width: 750px)').matches ? this.dataset.moveDesktop : this.dataset.moveMobile;
      return parseInt(v, 10) || 1;
    }
    pages() { return Math.max(1, this.slides.length - this.perView() + 1); }
    index() {
      const left = this.track.scrollLeft, start = this.slides[0] ? this.slides[0].offsetLeft : 0;
      let best = 0, dist = Infinity;
      this.slides.forEach((s, i) => { const d = Math.abs(s.offsetLeft - start - left); if (d < dist) { dist = d; best = i; } });
      return best;
    }
    scrollToIndex(i) {
      const s = this.slides[i];
      if (!s) return;
      this.track.scrollTo({ left: s.offsetLeft - this.slides[0].offsetLeft, behavior: 'smooth' });
    }
    go(dir, auto) {
      const last = this.pages() - 1;
      let i = this.index() + dir * this.perMove();
      if (i > last) i = (this.loop || auto) ? 0 : last;
      if (i < 0) i = this.loop ? last : 0;
      this.scrollToIndex(i);
    }
    build() {
      const n = this.pages();
      if (this.dots && this.dots.children.length !== n) {
        this.dots.innerHTML = '';
        for (let i = 0; i < n; i++) {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'mel-slider__dot';
          b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          b.addEventListener('click', () => this.scrollToIndex(i));
          this.dots.appendChild(b);
        }
      }
      this.classList.toggle('mel-slider--static', n <= 1);
      this.update();
    }
    update() {
      const i = this.index(), last = this.pages() - 1;
      if (this.dots) [...this.dots.children].forEach((d, k) => d.classList.toggle('is-active', k === i));
      if (!this.loop) {
        if (this.prev) this.prev.disabled = i <= 0;
        if (this.next) this.next.disabled = i >= last;
      }
    }
  });
}
